module.exports = __webpack_public_path__ + "img/pricing-header.6c1e9bdb.svg";